import "./new-patient.scss";

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormPatient from "../form-patient/form-patient";
import { useNewPatient } from "./new-patient.hook";

export function NewPatient() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewPatient();

  return (
    <div id="NewPatient" className="patient">
      <HeaderContent
        title={<h1>New Patient</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 gap-2 mb-4">
            <FormPatient />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewPatient;
